export default "__VITE_ASSET__26bf2d81__"